// extracted by mini-css-extract-plugin
export default {"wrapper":"ss-z","response":"ts-z","error":"us-z","disabled":"vs-z","buttons":"ws-z","feedbackQuestionSection":"xs-z","yesNoWrapper":"ys-z"};